import axios from "axios";
import constants from "constants";
import { store } from "store";
import errorHandler from "./errorHandler";

/*
	TODO Write a network layer before axios,
	Handle cancellation of network call or ignoring stale response
	Camelize all api keys at deep level
*/

const auth = axios.create({
	// TODO: Remove this check after complete migration of auth service
	baseURL: ["development", "staging", "production", "uat", "local"].includes(constants.env) ? `${constants.authServiceUrl}/` : `${constants.centralApiServerUrl}/`,
});
auth.interceptors.request.use((config) => {
	let userInfo = store.getState().userInfo;
	config.headers[constants.authTokenAuthServiceKey] = userInfo.authToken;
	config.headers["sessionID"] = userInfo.sessionId;
	return config;
});

auth.interceptors.response.use(function (response) {
	return response;
}, errorHandler);

export default auth;
